export const users = {
    route: 'Správa užívateľov',
    routeTitle: 'Správa užívateľov aplikácie',
    listOfUsers: 'Zoznam užívateľov',
    addUser: 'Pridať užívateľa',
    editUser: 'Upraviť užívateľa',
    deleteUser: 'Vymazať užívateľa',
    deleteUserButton: 'Vymazať',
    deleteUserConfirmTitle: 'Naozaj chcete vymazať tento záznam?',
    deleteUserConfirmDescription: ['Užívateľ', 'bude po potvdení natrvalo vymazaný.'],
    loginLabel: 'Prihlasovacie meno',
    firstNameLabel: 'Meno',
    lastNameLabel: 'Priezvisko',
    passwordLabel: 'Heslo',
    oldPasswordLabel: 'Staré heslo',
    newPasswordLabel: 'Nové heslo',
    confirmNewPasswordLabel: 'Nové heslo znova',
    confirmPasswordLabel: 'Heslo znova',
    confirmPasswordNotCorrect: 'Heslá, ktoré ste zadali, nie sú totožné!',
    addUserAsAdmin: 'Nastaviť užívateľa ako administrátora',
    addUserAsTester: 'Nastaviť užívateľa ako testera',
    addUserAsInstaller: '[sk] Set user as installer',
    changeUserPassword: 'Zmeniť užívateľské heslo',
    permissionsLabel: 'Oprávnenia',
    permissionsIsAdminTag: 'Administrátor',
    permissionsIsTesterTag: 'Tester',
    permissionsIsNotAdminTag: 'Správca'
};
